import React, { Component } from 'react';
import Head from 'next/head';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
class pageHead extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Head>
          <title>{this.props.title ? this.props.title : 'AXLR DATA '}</title>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
          <meta id="english-canonical-url" content="" />
          <meta name="title" content={this.props.meta ? this.props.meta.metatitle : 'AXLR DATA Meta Title'} />
          <meta name="description" content={this.props.meta ? this.props.meta.metaDescription : 'AXLR DATA Meta Description'} />
          <meta name="keywords" content={this.props.meta ? this.props.meta.metaKeywords : 'AXLR DATA Meta Keywords'} />
          <meta property="og:image" content="" />
          <meta name="twitter:widgets:csp" content="on" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href={`${publicRuntimeConfig.staticFolder}/images/favicon.png`} />
        </Head>
      </div>
    );
  }
}
export default pageHead;
